import { render } from "./DialogEditRiser.vue?vue&type=template&id=2af8e34a&ts=true"
import script from "./DialogEditRiser.ts?vue&type=script&lang=ts"
export * from "./DialogEditRiser.ts?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__